import { signal } from '@angular/core';

export interface PaginaInfo {
  nome: string;
  rota: string;
}

export const paginasBreadcrumb = signal<PaginaInfo[]>([]);

export const pushPaginaAtiva = (item: PaginaInfo): void => {
  paginasBreadcrumb.update(current => [...current, item]);
};

export const popPaginaAtiva = (index: number): void => {
  paginasBreadcrumb.update(current => {
    if (index < 0 || index >= current.length) {
      return current;
    }
    return current.slice(0, index + 1);
  });
};

export const clearPaginas = (): void => {
  paginasBreadcrumb.set([]);
};

